<section class="dynamic-form-wrapper">
  <section class="dynamic-form-header" *ngIf="title || subTitle">
    <span class="dynamic-form-title" [class]="unitHeaderClass" [ngClass]="titleClass"> {{title | translate}}</span>
    <span class="dynamic-form-subTitle" [ngClass]="{'subTitle-cls':subTitle}">{{subTitle | translate}}</span>
  </section>
  <div class="form-container">
    <form [formGroup]="dynamicForm" (ngSubmit)="onSubmit(dynamicForm)"
          novalidate
          *ngIf="load"
          class="dynamic-form-items-wrapper form-group"
          [ngClass]="{'dynamic-form-items-wrapper-column':formVertical,'dynamic-form-items-wrapper-row':!formVertical,'form-mode':!editMode,'edit-mode':editMode}">
      <section class="dynamic-form-items">
        <ng-container *ngFor="let item of formConfig | filterTypes:['hidden'] ;trackBy: trackByFn.bind(this); let itemIndex = index">
          <gen-form-item class="dynamic-form-single-item dynamic-form-item-named-{{item?.name}}"
                         *ngIf="!item.additional?.removed"
                         [ngClass]="[item?.additional?.reflectStyleClasses||'',item?.cssClass||'']"
                         [class.diff_marker]="item?.additional && item?.additional['diff']"
                         [class.dynamic-form-item-element-tag]="!formItemFullWidth"
                         [class.dynamic-form-item-element-tag-fullWidth]="formItemFullWidth === true"
                         [mode]="mode"
                         [editMode]="editMode"
                         [disabled]="isRootItem(item) ? disabled : dynamicForm.controls[item.name]?.disabled"
                         (forceChangeEmitter)="forceChange =  $event"
                         (itemTouched)="updateLastTouch($event)"
                         (itemBlured)="triggerValidate()"
                         (linkClick)="linkClicked($event)"
                         (onAddControl)="addControl($event)"
                         (submitUpdateEmitter)="updateSubmitStatus($event)"
                         [formInstance]="dynamicForm"
                         [additionalSearchValues]="additionalSearchValues"
                         [isIE]="isIE"
                         [formBaseWidgetPayload]="formBaseWidgetPayload"
                         [submitted]="submitted"
                         [item]="item"
                         [itemIndex]="itemIndex"
                         [requiredMessage]="requiredMessage"
                         [formId]="formId || formName"
                         [popupMode]="popupMode"
                         [stayInFormMode]="stayInFormMode"
                         [textAreaResizable]="item.textAreaResizable"
                         [textMinHeight]="item.textMinHeight"
                         [textMaxHeight]="item.textMaxHeight"
                         [defaultList]="_defaultList"
                         [disabledOptions]=disabledOptions>
            <ng-template #containerContent
                         let-type="payload"
                         let-item="item"
                         let-value="value">
              <ng-content select="[container-content]" container-content></ng-content>
            </ng-template>
            <ng-template #contextMenu
                         let-value="getter"
                         let-active="active"
                         let-updateFn="setter"
                         let-payload="payload"
                         let-type="type">
              <gen-generic-context-menu [active]="active"
                                        [value]="value() && value()[payload?.value] || value()"
                                        (update)="updateFn($event)"
                                        [type]="type"
                                        [coordinates]="{x:payload?.x,y:payload?.y}"
              >
                <ng-content></ng-content>
              </gen-generic-context-menu>
            </ng-template>
          </gen-form-item>
        </ng-container>
      </section>
      <section class="dynamic-form-note-wrapper" *ngIf="note">
        <span class="dynamic-form-note-text">
          {{note}}
        </span>
      </section>
      <section  class="dynamic-form-buttons-wrapper">
        <gen-button [type]="'quite'"
                    class="Auto_Button_Form_Cancel"
                    *ngIf="!!cancelButtonText || !!(hideActionButtonsOnDisable && disabled)"
                    [disabled]="disabled"
                    (click)="cancelClick()"
                    [text]="cancelButtonText">
        </gen-button>
        <gen-button class="Auto_Button_Form_Submit"
                    *ngIf="!!submitButtonText || !!(hideActionButtonsOnDisable && disabled)"
                    [disabled]="disabled"
                    [submit]="true"
                    [type]="'primary'"
                    [text]="submitButtonText">
        </gen-button>
      </section>
    </form>
  </div>
  <gen-overlay-loader class="loader" *ngIf="!load" [loaderType] = "loaderType"  [showOverlay]="false"></gen-overlay-loader>
</section>
